{
  "nav": {
    "dashboard": "Übersicht",
    "fleet": "Fuhrpark",
    "alerts": "Alarme",
    "history": "Verlauf",
    "health": "Gerätezustand",
    "geofences": "Geofences",
    "reports": "Berichte",
    "settings": "Einstellungen",
    "admin": "Admin",
    "more": "Mehr"
  },
  "dashboard": {
    "underProtection": "Unter Schutz",
    "fleetOnline": "Fuhrpark online",
    "allConnected": "Alle verbunden",
    "offline": "offline",
    "costPerKm": "Kosten / km · heute",
    "noTripsToday": "Noch keine Fahrten heute",
    "theftEvents": "Diebstahlereignisse",
    "theftPrevented": "Diebstahl verhindert",
    "activeTheft": "Aktiver Diebstahl",
    "noActiveTheft": "Keine aktiven",
    "caught": "erkannt",
    "requiresAttention": "Erfordert Aufmerksamkeit",
    "noTheftDetected": "Kein Diebstahl erkannt",
    "fleetMap": "Fuhrparkkarte",
    "liveMap": "Livekarte",
    "online": "Online",
    "alert": "Alarm",
    "value": "Wert",
    "lastEvent": "Letztes Ereignis",
    "lastSeen": "Zuletzt gesehen",
    "viewDetails": "Details anzeigen",
    "reviewAlerts": "Prüfen",
    "refuel": "Betankung",
    "noTrucksInFleet": "Keine Fahrzeuge im Fuhrpark",
    "addFirstTruck": "Ersten Truck hinzufügen",
    "goToFleet": "Öffne den Fuhrpark-Tab, um deinen ersten Truck hinzuzufügen und die Kraftstoffüberwachung zu starten.",
    "refuelSchedule": "Tankplan",
    "needAttention": "Fahrzeug benötigt Aufmerksamkeit",
    "needAttentionPlural": "Fahrzeuge benötigen Aufmerksamkeit",
    "critical": "kritisch",
    "high": "hoch",
    "medium": "mittel",
    "emptyIn": "Leer in",
    "updatedAgo": "Aktualisiert",
    "secondsAgo": "s",
    "minutesAgo": "m",
    "live": "Live",
    "liveHint": "Echtzeit-Updates verbunden",
    "signOut": "Abmelden"
  },
  "fleet": {
    "trucks": "Fahrzeuge",
    "truck": "Fahrzeug",
    "fuel": "Kraftstoff",
    "status": "Status",
    "lastSeen": "Zuletzt gesehen",
    "online": "Online",
    "offline": "Offline",
    "never": "Nie",
    "search": "Fahrzeuge suchen…",
    "addTruck": "Fahrzeug hinzufügen",
    "noTrucks": "Noch keine Fahrzeuge"
  },
  "truckDetail": {
    "fuelLevel": "Füllstand",
    "history": "Verlauf",
    "consumption": "Verbrauch",
    "location": "Standort",
    "close": "Schließen",
    "liters": "L",
    "full": "voll",
    "empty": "leer"
  },
  "alerts": {
    "title": "Alarme",
    "subtitle": "Kraftstoff-Sicherheitsereignisse im Fuhrpark bestätigen und lösen",
    "theft": "Diebstahl erkannt",
    "correlated": "Koordinierter Diebstahl",
    "tamper": "Manipulation erkannt",
    "geofence": "Geofence-Verletzung",
    "afterHours": "Bewegung außerhalb der Geschäftszeiten",
    "anomaly": "Anomalie",
    "acknowledge": "Bestätigen",
    "acknowledged": "Bestätigt",
    "resolve": "Lösen",
    "markResolved": "Als gelöst markieren",
    "reopen": "Alarm wieder öffnen",
    "evidence": "Nachweis",
    "downloadEvidence": "Nachweis herunterladen (PDF)",
    "statusOpen": "Offen",
    "statusAcknowledged": "Bestätigt",
    "statusResolved": "Gelöst",
    "tab_open": "Offen",
    "tab_acknowledged": "Bestätigt",
    "tab_resolved": "Gelöst",
    "tab_all": "Alle",
    "loadError": "Alarme konnten nicht geladen werden.",
    "emptyOpen": "Keine offenen Alarme",
    "emptyGeneric": "Keine Alarme vorhanden",
    "emptyHint": "Alles in Ordnung — keine Kraftstoff-Sicherheitsereignisse erfordern Ihre Aufmerksamkeit.",
    "unknownTruck": "Unbekanntes Fahrzeug",
    "litresLost": "Verlorene Liter",
    "valueLost": "Verlorener Wert",
    "tank": "Tank",
    "tankLeft": "Links",
    "tankRight": "Rechts",
    "speed": "Geschwindigkeit",
    "location": "Standort",
    "acknowledgedBy": "Bestätigt von",
    "resolvedBy": "Gelöst von",
    "resolutionPlaceholder": "Lösungsnotiz hinzufügen (optional)…",
    "ackDone": "Alarm bestätigt",
    "resolveDone": "Alarm gelöst",
    "reopenDone": "Alarm wieder geöffnet",
    "detection": "Erkennung",
    "verdict_high": "Hohe Konfidenz",
    "verdict_medium": "Mittlere Konfidenz",
    "verdict_low": "Niedrige Konfidenz",
    "markFalsePositive": "Als Fehlalarm markieren",
    "falsePositiveDone": "Als Fehlalarm markiert",
    "falsePositiveTag": "Fehlalarm",
    "confidence": "Konfidenz"
  },
  "settings": {
    "profile": "Mein Profil",
    "organization": "Organisation",
    "alertsNotifications": "Benachrichtigungen",
    "webhooks": "Webhooks",
    "team": "Team",
    "devices": "Geräte",
    "displayName": "Anzeigename",
    "emailAddress": "E-Mail-Adresse",
    "language": "Sprache",
    "changePassword": "Passwort ändern",
    "currentPassword": "Aktuelles Passwort",
    "newPassword": "Neues Passwort",
    "saveChanges": "Änderungen speichern",
    "profileUpdated": "Profil aktualisiert"
  },
  "auth": {
    "signIn": "Anmelden",
    "signingIn": "Anmelden…",
    "email": "E-Mail",
    "password": "Passwort",
    "forgotPassword": "Passwort vergessen?",
    "welcomeBack": "Schütze deinen Fuhrpark"
  },
  "common": {
    "loading": "Lädt…",
    "error": "Etwas ist schiefgelaufen",
    "retry": "Erneut versuchen",
    "cancel": "Abbrechen",
    "save": "Speichern",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "add": "Hinzufügen",
    "confirm": "Bestätigen",
    "close": "Schließen",
    "search": "Suchen",
    "noData": "Keine Daten",
    "ago": "vor",
    "liters": "L",
    "km": "km"
  },
  "push": {
    "title": "Diebstahl-Alarme in Echtzeit erhalten",
    "body": "Aktivieren Sie Benachrichtigungen und Tankguard meldet sich auf Ihrem Handy, sobald ein Diebstahl-, Manipulations- oder Tankstand-Ereignis auftritt — auch wenn die App geschlossen ist.",
    "allow": "Alarme aktivieren",
    "later": "Später",
    "enabled": "Echtzeit-Alarme aktiviert",
    "blocked": "Benachrichtigungen sind in Ihren Browsereinstellungen blockiert. Erlauben Sie sie für diese Seite, um Alarme zu erhalten.",
    "failed": "Benachrichtigungen konnten nicht aktiviert werden. Bitte erneut versuchen."
  },
  "install": {
    "title": "Tankguard zum Startbildschirm hinzufügen",
    "body": "Installieren Sie die App für Vollbild-Zugriff auf Ihre Flotte mit einem Tipp.",
    "action": "Installieren",
    "dismiss": "Später"
  }
}
